import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../authentication/auth.service';
import { OrgType } from '../authentication/user-org-types.enum';

export const orgTypeGuardFn: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  const authService = inject(AuthService);
  const expectedOrgTypes = route.data['expectedOrgTypes'] as OrgType[];
  const orgType = authService.userWithRoles.user.orgType;

  if (expectedOrgTypes.includes(orgType)) {
    return true;
  }

  authService.logout();
  return false;
};
